// @flow
import styled from '@emotion/styled';
import type { BlokComponentPropsType } from '../types';

const CodeBlock = styled.span`
  padding: 3px;
  border: 1px solid darkred;
  border-radius: 4px;
  background-color: rgba(255, 200, 200, 0.8);
  color: darkred;
`;

const ComponentNotFound = (
  props: BlokComponentPropsType<> & { customPath?: string }
) => {
  const {
    blok,
    customPath = 'components/editable/renderComponent.jsx'
  } = props;
  const name =
    blok && (blok.component || (blok.content && blok.content.component));
  console.warn(`ComponentNotFound( ${name} ) Props:`, props);
  return (
    <div>
      Component <CodeBlock>{name}</CodeBlock> is not defined.
      <br />
      Please ask a developer to add it to <CodeBlock>{customPath}</CodeBlock>
    </div>
  );
};

export default ComponentNotFound;
